// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CharacterSheetSuperiorityAddManeuver_checkbox_1UkU2"};